import styled from 'styled-components'

import Icon from 'components/Icon.v2'
import { mobileFirstMedia as media } from 'utils/media'
import IconV2 from 'components.v2/Icon/IconV2'

export const VendorHeaderContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: ${props => (props.isOffline ? '116px' : '78px')};
  z-index: 1000;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;

  ${media.screen`
    border-top: 3px solid ${props => props.theme.colors.orange};  
  `}
`

export const VendorHeaderItemStatus = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1002;
  display: flex;
  flex-direction: row;
  height: ${props => (props.isOffline ? '52px' : '0px')};
`

export const VendorHeaderItemInfo = styled.div`
  position: absolute;
  top: ${props => (props.isOffline ? '52px' : '0')};
  left: 0;
  right: 0;
  height: 78px;
  z-index: 1001;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  background-color: ${props => props.theme.colors.white};
  display: flex;
  flex-direction: row;
  justify-content: flext-start;
  align-items: left;
  padding: 0px 15px;
`

export const WhiteOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 78px;
  z-index: 1000;
  background-color: ${props => props.theme.colors.white};
`

export const InfoSection = styled.section`
  display: flex;
  position: relative;
  width: 100%;
  align-items: center;
  gap: 12px;
`

export const InfoSectionImg = styled.div`
  display: flex;
  margin-right: 15px;
  min-width: 40px;
`

export const InfoSectionRows = styled.section`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  text-align: ${p => p.isCenter ? 'center' : 'left'};
`

export const VenueName = styled.h1`
  margin: 2px 0;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;

  ${media.screen`
    font-size: 16px;
    font-weight: 500;
  `}
`

export const TagsContainer = styled.section`
  margin: 2px 0;
  display: flex;
  align-items: center;
  color: #808080;
  line-height: 125%;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-family: 'Montserrat', sans-serif !important;
  font-size: 12px;
  font-weight: 500;
  width: 100%;

  ${media.screen`
    font-size: 11px;
    font-weight: 300;  
  `}
`

export const Tags = styled.div`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`

export const TagsSeparator = styled.b`
  font-size: 1.25em;
  padding: 0 3px;
`

export const HeaderIcon = styled(Icon)`
  cursor: pointer;
`

export const Back = styled(IconV2)`
  margin-right: auto;
  cursor: pointer;
`

export const HeaderButtonSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`
